// General
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseurl = 'https://tprod-api.tuyak.com.tr/api/Auth/';

// Async Thunks
export const login = createAsyncThunk('backend_login', async ({ email, password }) => {
  try {
    const res = await axios.post(`${baseurl}login`, { email, password }, { withCredentials: true });
    return res.data;
  } catch (error) { throw error.response.data || error; }
});
export const refresh = createAsyncThunk('backend_refresh', async () => {
  try {
    const res = await axios.post(`${baseurl}refresh-token`, {}, { withCredentials: true });
    return res.data;
  } catch (error) { throw error.response.data || error; }
});
export const logout = createAsyncThunk('backend_logout', async () => {
  try {
    const res = await axios.get(`${baseurl}Logout`, { withCredentials: true });
    return res.data;
  } catch (error) { throw error.response.data || error; }
});
export const getUserInfo = createAsyncThunk('backend_getuserinfo', async () => {
  try {
    const res = await axios.get(`${baseurl}user-info`, { withCredentials: true });
    return res.data;
  } catch (error) { throw error.response.data || error; }
});

// Slice
const loginSlice = createSlice({
  name: 'auth',
  initialState: {
    userinfo: null,
    refreshStatus: null,
    loginStatus: null,
    logoutStatus: null,
    userInfoStatus: null,
    error: null
  },
  reducers: {
    resetLoginStatus: (state) => { state.loginStatus = null; },
    resetRefreshStatus: (state) => { state.refreshStatus = null; },
    resetLogoutStatus: (state) => { state.logoutStatus = null; },
    resetUserInfoStatus: (state) => { state.userInfoStatus = null; },
    resetError: (state) => { state.error = null; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => { state.loginStatus = 'pending'; state.error = null; })
      .addCase(login.fulfilled, (state) => { state.loginStatus = 'fulfilled'; state.error = null; })
      .addCase(login.rejected, (state, action) => { state.loginStatus = 'rejected'; state.error = action.error.message; })
      .addCase(refresh.pending, (state) => { state.refreshStatus = 'pending'; state.error = null; })
      .addCase(refresh.fulfilled, (state) => { state.refreshStatus = 'fulfilled'; state.error = null; })
      .addCase(refresh.rejected, (state, action) => { state.refreshStatus = 'rejected'; })
      .addCase(logout.pending, (state) => { state.logoutStatus = 'pending'; })
      .addCase(logout.fulfilled, (state) => { state.logoutStatus = 'fulfilled'; })
      .addCase(logout.rejected, (state) => { state.logoutStatus = 'rejected'; })
      .addCase(getUserInfo.pending, (state) => { state.userInfoStatus = 'pending'; })
      .addCase(getUserInfo.fulfilled, (state, action) => { state.userInfoStatus = 'fulfilled'; state.userinfo = action.payload; })
      .addCase(getUserInfo.rejected, (state) => { state.userInfoStatus = 'rejected'; state.userinfo = null; });
  }
});

export const { resetLoginStatus, resetRefreshStatus, resetLogoutStatus, resetUserInfoStatus, resetError } = loginSlice.actions;
export default loginSlice.reducer;